export const AboutUs=()=>{
    return(<>
        <div className="w-screen h-screen p-8">
                <h1 className="text-center text-4xl font-bold">About Us</h1>

                {/* Content here */}
        </div>  
        <div className="content">

        </div>
        </>
    )
}